import { TestEmail, TestEmailParams, TestEmailResult } from '@/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/domain/errors'
import { HttpClient, HttpStatusCode } from '@/data/protocols/http'

export type TestEmailApiResponse = boolean | {
  sucesso: boolean
  mensagem: string
}

export class RemoteTestEmail implements TestEmail {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<TestEmailApiResponse>
  ) { }

  async test (params: TestEmailParams): Promise<TestEmailResult> {
    const { statusCode, body } = await this.httpClient.request({
      method: 'post',
      url: `${this.url}/api/portal/testaemail`,
      body: params
    })

    switch (statusCode) {
      case HttpStatusCode.ok: return this.adaptResult(body)
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
  private adaptResult (body: TestEmailApiResponse): TestEmailResult {
    if (typeof body === 'object' && body !== null) {
      return { success: Boolean(body.sucesso), message: body.mensagem || '' }
    }

    return { success: Boolean(body), message: '' }
  }
}
